import { Store } from "@omni/types/api/store/bff/store.model";

import { StoreAddress } from "@/components/Address/Address/address.component";
import { useStoreFullName } from "@/components/Store/utils/useStoreFullName.hook";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type OrderClickAndCollectDetailsBlockProps = {
    pickUpTime: string;
    store?: Store | null;
};

const OrderClickAndCollectDetailsBlock = ({
    pickUpTime,
    store
}: OrderClickAndCollectDetailsBlockProps) => {
    const { t } = useGranite();

    const storeFullName = useStoreFullName(store);

    return (
        <>
            <h4>{t("orderOverview.title.clickAndCollect")}</h4>
            {pickUpTime && <div className="mb-4">{pickUpTime}</div>}

            {store && (
                <StoreAddress
                    storeName={storeFullName}
                    address={store.address}
                />
            )}
        </>
    );
};

export default OrderClickAndCollectDetailsBlock;
